var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "content-container" },
    [
      _c(
        "v-card",
        { staticClass: "rounded-16 pa-5", attrs: { outlined: "" } },
        [
          _c(
            "v-row",
            {
              staticClass: "mb-4",
              attrs: { align: "center", justify: "space-between", dense: "" },
            },
            [
              _c("v-col", { attrs: { cols: "auto" } }, [
                _c("h5", { staticClass: "text-h5 font-weight-medium" }, [
                  _vm._v("Find codes and standards"),
                ]),
              ]),
              _vm._v(" "),
              _c("v-col", { attrs: { cols: "auto" } }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "text-body-1 font-weight-medium text-decoration-underline tracking_home_link_browse_codes",
                    attrs: { href: _vm.getRoute("codes") },
                  },
                  [
                    _vm._v(
                      "\n                    Browse All Codes\n                    "
                    ),
                    _c("v-icon", { attrs: { color: "primary" } }, [
                      _vm._v("mdi-chevron-right"),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "category-list-buttons", attrs: { dense: "" } },
            _vm._l(_vm.menus, function (menu, index) {
              return _c("category-menu", {
                key: menu.title,
                attrs: {
                  title: menu.title,
                  btnClassName: menu.class,
                  "menu-groups": menu.groups,
                  "padding-left": _vm.getPadding(index, "left"),
                  "padding-right": _vm.getPadding(index, "right"),
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }